<template>
  <div>
    <van-popup
      closeable
      class="popup"
      v-model="show"
      position="bottom"
      :style="{ height: '74vw' }"
    >
      <p class="popup-title">全部分类</p>
      <div class="tag-list">
        <div
          class="tag-item"
          v-for="(item, index) in list"
          :key="index"
          @click="selectTag(index)"
        >
          <span class="tag-span">{{ item.name }}</span>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => {
        return []
      }
    },
    active: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      show: false
    }
  },
  watch: {},
  methods: {
    selectTag(index) {
      this.$emit('change', index)
      this.show = false
    }
  }
}
</script>
<style lang="scss" scoped>
.popup {
  box-sizing: border-box;
  background-color: #f9f9f9;
  padding: 5.3vw;
  .popup-title {
    text-align: left;
    font-family: PingFangSC-Regular;
    font-size: 4vw;
    color: #000;
    margin-bottom: 5.3vw;
  }
}
.tag-list {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  .tag-item {
    box-sizing: border-box;
    white-space: nowrap;
    padding: 0vw 2vw;
    margin-right: 2.5vw;
    margin-bottom: 2.7vw;
    width: 28vw;
    height: 9.6vw;
    line-height: 9.6vw;
    background-color: #ffffff;
    border-radius: 2.7vw;
    font-family: PingFangSC-Regular;
    font-size: 3.5vw;
    color: #000;
    text-align: center;
    .tag-span {
      display: inline-block;
      text-align: left;
    }
  }
  .tag-item:nth-child(3n) {
    margin-right: 0vw;
  }
}
</style>
